// @flow
/* eslint jsx-a11y/no-noninteractive-element-interactions: 0*/
import React, { useReducer, useRef } from "react";
import "./styles.css";
import uuid from "uuid";
import withValidation from "../with-validation";
import classNames from "classnames";

const type = "file";
const excludedProps = ["children", "className", "errorMessage", "readyMessage", "isError", "labelText", "value"];


const canDrag = (() => {
    const div = document.createElement("div");
    return (("draggable" in div) || ("ondragstart" in div && "ondrop" in div)) && "FormData" in window && "FileReader" in window;
})();


function reducer(state, action) {
    switch (action.type) {
        case "SET_IS_DRAGGING":
            return { ...state, dragging: action.payload };
        case "SET_STATE":
            return { ...state, ...action.payload };
        default:
            throw new Error();
    }
}


type PropsType = {
    id: string,
    disabled: ?boolean,
    errorMessage: ?string,
    isError: ?boolean,
    labelText: ?string,
    onChange: any => any,
    className?: string,
    readOnly: ?boolean,
    readyMessage: ?string,
    required: ?boolean,
    style: ?Object,
    'data-multiple-caption': string,
    name: string
};

const MyComponent = ({
    id = uuid(),
    disabled = false,
    errorMessage = "Error",
    isError = false,
    className,
    labelText,
    onChange,
    readOnly = false,
    readyMessage,
    required = false,
    style,
    name = "files[]"
}: PropsType) => {
    const [state, dispatch] = useReducer(reducer, { fileNames: [], isDragging: false, isError: false, isUploading: false, isReady: false });
    const inputEl = useRef(null);

    const componentClass = classNames("file-upload", {
        "is-uploading": state.isUploading,
        "is-required": required,
        "is-error": isError,
        "is-disabled": disabled,
        "is-read-only": readOnly,
        "can-drag": canDrag,
        "is-dragging": state.isDragging,
        "is-ready": state.isReady,
        [className || "foo"]: className
    });

    const handleFileSelect = (e) => {
        const files = Array.from(e.target.files);
        const fileNames = files.map(f => f.name);
        dispatch({
            type: "SET_STATE",
            payload: {
                isReady: fileNames.length > 0,
                fileNames
            }
        });
        if (onChange) {
            onChange(files);
        }
    };

    return (
        <article
            className={ componentClass }
            onDragEnter={ (e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch({ type: "SET_IS_DRAGGING", payload: true });
            } }
            onDragLeave={ (e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch({ type: "SET_IS_DRAGGING", payload: false });
            } }
            onDragOver={ (e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch({ type: "SET_IS_DRAGGING", payload: true });
            } }
            onDrop={ (e) => {
                e.persist();
                e.preventDefault();
                e.stopPropagation();
                const files = [...e.dataTransfer.files];
                dispatch({
                    type: "SET_STATE",
                    payload: {
                        isDragging: false,
                        isReady: Boolean(files),
                        fileNames: files.map(f => f.name)
                    }
                });
                if (onChange) {
                    onChange(files);
                }
            } }
        >
            <input
                id={ id }
                className={ "file-upload--input" }
                multiple={ false }
                value={ "" }
                type={ "file" }
                onChange={ handleFileSelect }
                ref={ inputEl }
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label className="file-upload--label-text" htmlFor={ id }>
                <div className={ "file-upload--message-wrapper" }>
                    <strong>{labelText || "Choose a file"}</strong>
                    <span className="file-upload--dragNdrop">{" or drag it here"}</span>
                    <div className="file-upload--is-ready">
                        {readyMessage || (state.fileNames).map(fileName => (
                            <div className={ "file--upload--file-name" } key={ fileName }>{fileName}</div>))}
                    </div>
                    <div className="file-upload--error">{errorMessage || "Error!"}</div>
                </div>
            </label>
        </article>
    );
};


export const FileUpload = withValidation(MyComponent);
